<template>
    <main class="main" id="main">
        <navigate></navigate>
        <section class="section s-lk">
            <div class="container">
                <input type="text" name="datetimes" id="stats_range" class="range_input"/>
                <div class="statistic_table_box">
                    <table class="statistic_table" id="statistic_table">
                        <thead>
                        <tr class="row">
                            <th>Город</th>
                            <th>Всего</th>
                            <th>Заполнено</th>
                            <th>Договоров подписано</th>
                            <th v-for="(cat, index) in cats" :key="index">{{cat}}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr class="row" @click="currentCity = name" v-for="(city, name) in stats" :key="name">
                                <td class="td control_trigger">{{name}}</td>
                                <td class="td control_trigger">{{city.all}}</td>
                                <td class="td control_trigger">{{city.count}}</td>
                                <td class="td control_trigger">{{city.account}}</td>
                                <td :class="parseInt(city.cats[index]) === 0 ? 'td red' : 'td green'" v-for="(cat, index) in cats" :key="index">{{city.cats[index]}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
        <section class="section s-lk" v-if="currentCity">
            <div class="container">
                <h1>Рестораны г.{{currentCity}}</h1>
                <div class="statistic_table_box">
                    <table class="statistic_table" id="statistic_table2">
                        <thead>
                        <tr class="row">
                            <th>Ресторан</th>
                            <th>Работает</th>
                            <th>Договор</th>
                            <th v-for="(cat, index) in cats" :key="index">{{cat}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="row" v-for="(restaurant, index) in stats[currentCity].restaurants" :key="index">
                            <td>{{restaurant.name}}</td>
                            <td>{{restaurant.isWorking}}</td>
                            <td>{{restaurant.account}}</td>
                            <td :class="parseInt(restaurant.cats[index]) === 0 ? 'td red' : 'td green'" v-for="(cat, index) in cats" :key="index">{{restaurant.cats[index]}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import navigate from '@/pages/lk/user/navigate'
import $ from 'jquery'
import moment from 'moment'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
import axios from '@/router/http'
import 'daterangepicker/daterangepicker'
import 'daterangepicker/daterangepicker.css'
export default {
  name: 'stats',
  components: {
    navigate
  },
  props: ['city', 'auth', 'geo', 'user'],
  data () {
    return {
      range: {},
      stats: {},
      cats: {},
      currentCity: null
    }
  },
  created () {
    if (this.auth.uid && this.city.country_id) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid && this.city.country_id) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  mounted () {
    $('#stats_range').daterangepicker({
      language: 'ru',
      alwaysShowCalendars: true,
      ranges: {
        'Сегодня': [moment(), moment()],
        'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'За последние 7 дней': [moment().subtract(6, 'days'), moment()],
        'За последние 30 дней': [moment().subtract(29, 'days'), moment()],
        'В этом месяце': [moment().startOf('month'), moment().endOf('month')],
        'В прошлом месяце': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      'locale': {
        'format': 'MM/DD/YYYY',
        'separator': ' - ',
        'applyLabel': 'Принять',
        'cancelLabel': 'Отменить',
        'fromLabel': 'От',
        'toLabel': 'До',
        'customRangeLabel': '',
        'weekLabel': 'Н',
        'daysOfWeek': [
          'Вс',
          'Пн',
          'Вт',
          'Ср',
          'Чт',
          'Пт',
          'Сб'
        ],
        'monthNames': [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь'
        ],
        'firstDay': 1
      }
    }, (start, end, label) => {
      this.range = {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }
      this.currentCity = null
    })
  },
  watch: {
    stats () {
      if ($('#statistic_table.dataTable').length) $('#statistic_table').DataTable().destroy()
      setTimeout(() => {
        $('#statistic_table').DataTable({
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Поиск:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          },
          'scrollX': true,
          fixedHeader: {
            header: true
          }
        })
      }, 300)
    },
    currentCity (newVal, oldVal) {
      if ($('#statistic_table2.dataTable').length) $('#statistic_table2').DataTable().destroy()
      if (newVal && newVal !== oldVal) {
        setTimeout(() => {
          $('#statistic_table2').DataTable({
            'language': {
              'decimal': '',
              'emptyTable': 'No data available in table',
              'info': 'С _START_ до _END_ из _TOTAL_ записей',
              'infoEmpty': 'С 0 до 0 из 0 записей',
              'infoFiltered': '(filtered from _MAX_ total entries)',
              'infoPostFix': '',
              'thousands': ',',
              'lengthMenu': 'Выводить по _MENU_',
              'loadingRecords': 'Loading...',
              'processing': 'Processing...',
              'search': 'Поиск:',
              'zeroRecords': 'No matching records found',
              'paginate': {
                'first': 'First',
                'last': 'Last',
                'next': 'След',
                'previous': 'Пред'
              },
              'aria': {
                'sortAscending': ': activate to sort column ascending',
                'sortDescending': ': activate to sort column descending'
              }
            },
            'scrollX': true,
            fixedHeader: {
              header: true
            }
          })
        }, 300)
        // let tableOffset = $('#table-1').offset().top
        // let $header = $('#table-1 > thead').clone()
        // let $fixedHeader = $('#header-fixed').append($header)
        // $(window).bind('scroll', function () {
        // let offset = $(this).scrollTop()
        // if (offset >= tableOffset && $fixedHeader.is(':hidden')) {
        // $fixedHeader.show()
        // }
        // else if (offset < tableOffset) {
        //  $fixedHeader.hide()
        // }
        // })
      }
    },
    range () {
      if (this.range.start && !this.range.end) {
        axios.get('https://lk.when-hungry.com/mobile/new-stats?uid=' + this.auth.uid + '&date=' + this.range.start).then(response => {
          this.stats = response.data.stats
          this.cats = response.data.cats
        })
      } else {
        if (this.range.start && this.range.end) {
          axios.get('https://lk.when-hungry.com/mobile/new-stats?uid=' + this.auth.uid + '&start=' + this.range.start + '&end=' + this.range.end).then(response => {
            this.stats = response.data.stats
            this.cats = response.data.cats
          })
        }
      }
    }
  },
  methods: {
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/new-stats?uid=' + this.auth.uid + '&country=' + this.city.country_id).then(response => {
        this.stats = response.data.stats
        this.cats = response.data.cats
      })
    }
  }
}
</script>

<style>
    .vl-calendar {
        display: inline-block;
        position: relative;
        background: #F6F6F6;
        padding: 20px 0 0;
        text-align: center;
        color: #3E3A4E;
        font-size: 14px;
        user-select: none;
    }
    .vl-calendar__month {
        display: inline-block;
        margin-bottom: 30px;
        width: 300px;
    }
    .vl-calendar__arrow {
        position: absolute;
        top: 15px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 75%;
        cursor: pointer;
        width: 24px;
        height: 24px;
    }
    .vl-calendar__arrow--back {
        left: 15px;
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAA0lBMVEUZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjSTOY05AAAARnRSTlMAAQIDBAUGBwgJCgsMDQ8QERITFBUXGBkaGx0eHyAiIyQnKCkqKywtLi8wMTIzNDU2Nzg5Ojs8Pj9AQUJDREZHSElKS0xNUWPYUAAAAU1JREFUeNptk+lygjAURq8gFm2h1q3uWsVqtZUWXAGtIN/7v1KHSGxYzp9kcnKXJBMSUfRGXZMpl+rcRUS4f6tk5RYINovpdLkPEa7KCVmYhLBbUlyi78DvCrZowmuIuwc+DOJINmyFEjx5mPL5HJZEKVQPHWI04BQpgxZcHlihI6qUwwiLaGjh697iTP/X0ukahZv3YHmLcSJ8SCQFJ243WIstlmET6VjGySxuOa5P1MboZn/Slkyo1EePWRM4eRyL6SU0pm+Fcbmz5TpKztv+oGxyna8qu7R3g+hgHsV+n/QqNkT0jWfuDxgKesgu6RWfFFNa1YRHd0P1NuiUwyC+ryYOctY++r5K8fnMQtqWHPT4W+xgpuLLR8yJo1g4VkXb+YUhJCy8I1zzrqX2Dtdu9huc15Px2LB89g3S1FdnMJyZRrlUaq3mS4kE/gAULzTK6Ml9VwAAAABJRU5ErkJggg==");
    }
    .vl-calendar__arrow--forward {
        right: 15px;
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAz1BMVEUZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjQZJjTQKaQcAAAARXRSTlMAAQIDBAUGBwgJCgsMDg8QERITFBUWGBkaGx0eHyAhIiMkJSYnKCkqLC0uLzAxMjQ1Nzg5Ojs/QEFCQ0RFRkdISUpLTE22Gs8EAAABVUlEQVR4AW3T4XaaMBwF8IvKRp2dU5F266qwMWXT1bWjqbMUanLf/5nWcIzByO9L/udcJRcIaHo3DMeDDlqF64KafIzfwzUVZPWQLZZ3gpSZj6beb6rNxEMtiAu+TGEFgmIIq5sqNYPhC256ODEqeWvme/6C63KvRqh9Ze7hTMRdt65V7vto8ZPf9DLnAtbtzfEZvZYdAEIFsJ44t3+PgIA5GgYvx8pjroArfoeTH67fkQJIeAU3/3LYSAILTvQ43O6MiuoztJzdt3isx09FZezJ2TFOeI0TFztTXkhbrZEmptoTcMEHJzU/H3Gl+6nm4RD8Ycas3jZmCitNzORXZadeXgO0WB52mfEe50L13IPm/eUSrg+VCs2r+8e1c7o/Fozt3Wz5OIDlzSUTWP4fytWlOdU3W1bX55/B812aJFkuqdYBHF60qagpkfbRxutPounQR8N/jIU0mXzMHWoAAAAASUVORK5CYII=");
    }
    .vl-flex {
        display: flex;
        flex-wrap: wrap;
    }
    .vl-calendar-month {
        padding: 0 20px;
    }
    .vl-calendar-month__title {
        margin-bottom: 20px;
        text-align: center;
        font-weight: 600;
    }
    .vl-calendar-month__week-day {
        display: inline-block;
        margin-bottom: 10px;
        width: 14%;
        text-align: center;
        color: #C83F3A;
        font-size: 12px;
    }
    .vl-calendar-month__day {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 5px 0;
        cursor: pointer;
        width: 14%;
        height: 24px;
    }
    .vl-calendar-month__day--offset-1 {
        margin-left: calc(1 * 14%);
    }
    .vl-calendar-month__day--offset-2 {
        margin-left: calc(2 * 14%);
    }
    .vl-calendar-month__day--offset-3 {
        margin-left: calc(3 * 14%);
    }
    .vl-calendar-month__day--offset-4 {
        margin-left: calc(4 * 14%);
    }
    .vl-calendar-month__day--offset-5 {
        margin-left: calc(5 * 14%);
    }
    .vl-calendar-month__day--offset-6 {
        margin-left: calc(6 * 14%);
    }
    .vl-calendar-month__day.disabled {
        color: #B5B5B5;
        pointer-events: none;
    }
    .vl-calendar-month__day.disabled--first {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }
    .vl-calendar-month__day.disabled--last {
        border-top-right-radius: 14px;
        border-bottom-right-radius: 14px;
    }
    .vl-calendar-month__day.selected {
        background: #C83F3A;
        color: #FFF;
        font-weight: 800;
    }
    .vl-calendar-month__day.selected--first {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }
    .vl-calendar-month__day.selected--last {
        border-top-right-radius: 14px;
        border-bottom-right-radius: 14px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/stats.vue